import React, { Component } from 'react';
import AreaMap from '../components/AreaMap'
import Cart from '../components/Cart'


class FixBox extends Component {
    state ={fixFlg:false}
    componentDidMount() {
        window.addEventListener('scroll', this.updateScroll.bind(this)); // PropsにUpdater渡してあるので呼べる
    }
    componentWillUnmount() {
        window.removeEventListener('scroll', this.updateScroll); // Unmount時に外してあげる
    }
    updateScroll(){
        const scrollTop = Math.max(
            window.pageYOffset,
            document.documentElement.scrollTop,
            document.body.scrollTop
        )
        const fixFlg = ( 128 < scrollTop )
        this.setState({fixFlg:fixFlg})
    }
    setStylePosition(fixFlg){
        const scrollLeft = Math.max(
            window.pageXOffset,
            document.documentElement.scrollLeft,
            document.body.scrollLeft
        )
        if(fixFlg){
            return {
                position:'fixed',
                width: 'calc(100% - 400px)',
                minWidth: 580,
                top:3,
                left:(400 - scrollLeft),
            }
        }
        return {}
    }

    render() {
        return (
            <div className="FixBoxComponent" style={this.setStylePosition(this.state.fixFlg)}>
                <AreaMap />
                <Cart />
            </div>
        );
    }
}

export default FixBox



// WEBPACK FOOTER //
// ./src/components/FixBox.js